import React from 'react';
import '../css/header.css';
import LinkArrow from './v2/global/LinkArrow';

const AnnouncementBar = ({ handleClose }) => {
  return (
    <div className="announcement-bar z-50 fixed top-0 w-full h-10 bg-orange flex items-center">
      <div className="container mx-auto text-center text-white text-xs lg:text-base flex flex-col lg:flex-row items-center justify-center gap-x-4">
        <span className="text-xs lg:text-sm">
          New Guidebook: Intro to Reinforcement Fine-tuning
        </span>
        <LinkArrow
          to="https://go.predibase.com/en/the-complete-guide-to-rft-lp"
          color="white"
          size="xs"
        >
          Download Now
        </LinkArrow>
      </div>
      <button
        type="button"
        aria-label="Close"
        className="me-4"
        onClick={handleClose}
      >
        <svg viewBox="0 0 28 19" width="14" height="14">
          <g>
            <path
              id="Vector 1"
              d="M23 17.5L7 1.5"
              stroke="#ffffff"
              strokeWidth="3.1"
            />
            <path
              id="Vector 3"
              d="M23 1.5L7 17.5"
              stroke="#ffffff"
              strokeWidth="3.1"
            />
          </g>
        </svg>
      </button>
    </div>
  );
};

export default AnnouncementBar;
